import React, { useContext, useState } from "react";
import { assets } from "../assets/assets_frontend/assets";
import { NavLink, useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";

const NavBar = () => {
  const navigator =useNavigate()
  const {pic} =useContext(AppContext)
  const navigate = useNavigate();
  // const [ShowMenu, setMenu] = useState(false);
  const [tokin, setTokin] = useState(true);
  return (
    <div className="flex items-center py-4 mb-5 border-b border-b-gray-400 text-sm justify-between ">
      <img className=" w-44 cursor-pointer" src={assets.logo} alt="alt" />
      <ul className="hidden  md:flex items-start font-medium gap-4">
        <NavLink to="/">
          <li> HOME</li>
          <hr className=" outline-none h-.5 border-b border-b-gray-400 bg-primary w-3/5   m-auto hidden" />
        </NavLink>
        <NavLink to="/contact">
          <li> CONTACT</li>
          <hr className="   outline-none h-.5 border-b border-b-gray-400 bg-primary w-3/5   m-auto hidden" />
        </NavLink>
        <NavLink to="doctors">
          <li>ALL DOCTORS</li>
          <hr className="outline-none h-.5   bg-primary w-3/5 border-b border-b-gray-400   m-auto hidden" />
        </NavLink>
        <NavLink to="about">
          <li> ABOUT</li>
          <hr className="outline-none h-.5  bg-primary w-3/5 border-b border-b-gray-400   m-auto hidden" />
        </NavLink>
      </ul>
      <div>
        {tokin ? (
          <div className="flex gap-4  relative group cursor-pointer">
            <img 
              className="w-8 rounded-full"
              src={pic}
              alt="alt"
            />
            <img className="w-2.5" src={assets.dropdown_icon} alt="alt" />
            <div className="absolute top-0 right-0 pt-14 text-base text-gray-600 z-20 hidden group-hover:block w-44">
              <div className="bg-stone-100 flex flex-col gap-4 p-4 rounded">
                <p
                  onClick={() => {
                    navigate("/my-profile");
                  }}
                  className="hover:text-black cursor-pointer"
                >
                  my profile
                </p>
                <p
                  onClick={() => {
                    navigate("/my-appointments");
                  }}
                  className="hover:text-black cursor-pointer"
                >
                  my appointments
                </p>
                <p
                  onClick={() => {
                    setTokin(false);
                  }}
                  className="hover:text-black cursor-pointer"
                >
                  {" "}
                  logout
                </p>
              </div>
            </div>
          </div>
        ) : (
          <button
            onClick={() => {
              navigate("/login");
            }}
            className="hidden md:block bg-primary m-auto px-8 py-3  text-white  rounded-full"
          >
            create account
          </button>
        )}
      </div>
    </div>
  );
};

export default NavBar;
